import { useEffect, useState } from "react";
import api from "@/lib/api";
import { cad, shortId, when } from "@/components/sponsored/format";

export const MOVES = {
  TOPUP: ["Card top-up", 1], RESERVE: ["Set aside for Shop Again", -1], RELEASE: ["Set-aside returned", 1],
  CONSUME_RESERVED: ["Bonus reward funded from set-aside", 0], CONSUME_AVAILABLE: ["Bonus reward funded", -1], SETTLE: ["Bonus paid to shopper (was pending)", 0],
  REVERSE_PENDING: ["Bonus reversed (order refunded)", 1], REVERSE_SETTLED: ["Bonus reversed (order refunded)", 1],
  REFUND_HOLD: ["Refund requested", -1], REFUND_RELEASE: ["Returned to budget", 1], REFUNDED: ["Refunded to card (from refund hold)", 0],
};

export function LedgerRows({ rows, testid = "sc-ledger" }) {
  if (!rows.length) return <p className="text-sm text-slate-400 italic" data-testid={`${testid}-empty`}>No budget activity yet.</p>;
  return (
    <div className="overflow-x-auto" data-testid={testid}>
      <table className="w-full text-sm">
        <thead className="text-left text-[10px] uppercase tracking-widest text-slate-500">
          <tr><th className="pb-2 pr-3">When</th><th className="pb-2 pr-3">Movement</th><th className="pb-2 pr-3" title="+ / − = change to available budget; no sign = moved between held buckets">Amount</th><th className="pb-2 pr-3">Reference</th><th className="pb-2 pr-3">Available after</th></tr>
        </thead>
        <tbody>
          {rows.map((r) => {
            const [label, sign] = MOVES[r.type] || [r.type, 0];
            return (
              <tr key={r.id} className="border-t border-slate-100" data-testid={`${testid}-row-${r.id}`}>
                <td className="py-2 pr-3 text-xs text-slate-500 whitespace-nowrap">{when(r.created_at)}</td>
                <td className="py-2 pr-3">{label}</td>
                <td className={`py-2 pr-3 tabular-nums font-semibold ${sign > 0 ? "text-emerald-700" : sign < 0 ? "text-rose-700" : "text-slate-700"}`}>{sign > 0 ? "+" : sign < 0 ? "−" : ""}{cad(r.amount_cad)}</td>
                <td className="py-2 pr-3 font-mono text-xs whitespace-nowrap" title={r.order_id || r.ref_id || ""}>{r.order_id || shortId(r.ref_id, 10)}</td>
                <td className="py-2 pr-3 tabular-nums text-slate-600">{cad((r.balances_after?.available_minor ?? 0) / 100)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

export function LedgerTable() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/merchant/sponsored-cashback/ledger", { params: { limit: 100 } }).then((r) => setRows(r.data.rows)).catch(() => setRows([])); }, []);
  return rows ? <LedgerRows rows={rows} /> : <p className="text-sm text-slate-500">Loading…</p>;
}
